import { render, staticRenderFns } from "./PayState.vue?vue&type=template&id=28b6f5f8&scoped=true&"
import script from "./PayState.vue?vue&type=script&lang=js&"
export * from "./PayState.vue?vue&type=script&lang=js&"
import style0 from "./PayState.vue?vue&type=style&index=0&id=28b6f5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6f5f8",
  null
  
)

export default component.exports